import { render, staticRenderFns } from "./UserStatusBadge.vue?vue&type=template&id=112b941c&scoped=true"
import script from "./UserStatusBadge.vue?vue&type=script&lang=js"
export * from "./UserStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./UserStatusBadge.vue?vue&type=style&index=0&id=112b941c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b941c",
  null
  
)

export default component.exports